<template>
    <div id="rooms-wrapper" class="generic-wrapper">
        <h1 class="page-title">Habitaciones</h1>
        <div class="info-wrapper">
            <p class="body-text">Las 56 habitaciones del hotel cuentan con todos los servicios
                para brindar comodidad y confort durante su estadía y pueda disfrutar
                de una perfecta estancia tanto si viaja por trabajo o por placer.</p>
        </div>
        <div id="rooms-display">
            <RoomView v-for="r in rooms" :room-title="r.title" :capactiy="r.capacity"
                      :breakfast-count="r.breakfastCount" :images="r.images" :main-image="r.mainImage" />
        </div>
    </div>
</template>

<script>
    import RoomView from "../components/RoomView";

    export default {
        name: "Rooms",
        components: {RoomView},
        data() {
            return {
                'rooms': [
                    {
                        title: 'Habitación Sencilla',
                        capacity: 2,
                        breakfastCount: 1,
                        mainImage: require('../assets/images/rooms/sencilla-1_scaled.jpg'),
                        images: [
                            {
                                src: require('../assets/images/rooms/sencilla-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/sencilla-1.jpg'),
                                w: 4896,
                                h: 3672,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/sencilla-2.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/sencilla-2.jpg'),
                                w: 4320,
                                h: 3240,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/sencilla-3.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/sencilla-3.jpg'),
                                w: 4320,
                                h: 3240,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                    {
                        title: 'Habitación Doble',
                        capacity: 4,
                        breakfastCount: 2,
                        mainImage: require('../assets/images/rooms/doble-clasica-1_scaled.jpg'),
                        images: [
                            {
                                src: require('../assets/images/rooms/doble-clasica-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/doble-clasica-1.jpg'),
                                w: 4896,
                                h: 3672,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/doble-deluxe-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/doble-deluxe-1.jpg'),
                                w: 4896,
                                h: 3672,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/doble-deluxe-2.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/doble-deluxe-2.jpg'),
                                w: 1280,
                                h: 720,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                    {
                        title: 'Habitación Triple',
                        capacity: 6,
                        breakfastCount: 3,
                        mainImage: require('../assets/images/rooms/triple-2_scaled.jpg'),
                        images: [
                            {
                                src: require('../assets/images/rooms/triple-2.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/triple-2.jpg'),
                                w: 4896,
                                h: 3392,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/triple-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/triple-1.jpg'),
                                w: 2592,
                                h: 1944,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                    {
                        title: 'Habitación Cuádruple',
                        capacity: 8,
                        breakfastCount: 4,
                        mainImage: require('../assets/images/rooms/cuad-1_scaled.jpg'),
                        images: [
                            {
                                src: require('../assets/images/rooms/cuad-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/cuad-1.jpg'),
                                w: 4896,
                                h: 3672,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/rooms/cuad-2.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/cuad-2.jpg'),
                                w: 2592,
                                h: 1944,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                    {
                        title: 'Habitación Séxtuple',
                        capacity: 12,
                        breakfastCount: 6,
                        mainImage: require('../assets/images/rooms/sextuple-1_scaled.jpg'),
                        images: [
                            {
                                src: require('../assets/images/rooms/sextuple-1.jpg'),
                                thumbnail: require('../assets/images/rooms/scaled/sextuple-1.jpg'),
                                w: 4320,
                                h: 3240,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    #rooms-display {
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
    }
    .info-wrapper {
        margin-bottom: 50px;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {

    }
</style>